import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Tarieven from "@/pages/Tarieven";
import Zakelijk from "@/pages/Zakelijk";
import OverOns from "@/pages/OverOns";
import Kennisbank from "@/pages/Kennisbank";
import Artikel from "@/pages/Artikel";
import Partners from "@/pages/Partners";
import FaqPage from "@/pages/FaqPage";
import Contact from "@/pages/Contact";
import Aanvragen from "@/pages/Aanvragen";
import Beheer from "@/pages/Beheer";
import { PrivacyPage, VoorwaardenPage, CookiesPage } from "@/pages/Legal";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/tarieven" element={<Tarieven />} />
        <Route path="/zakelijk" element={<Zakelijk />} />
        <Route path="/over-ons" element={<OverOns />} />
        <Route path="/kennisbank" element={<Kennisbank />} />
        <Route path="/kennisbank/:slug" element={<Artikel />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aanvragen" element={<Aanvragen />} />
        <Route path="/privacyverklaring" element={<PrivacyPage />} />
        <Route path="/algemene-voorwaarden" element={<VoorwaardenPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
      </Route>
      <Route path="/beheer" element={<Beheer />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
